import { atom } from 'recoil';
import { TBulkDownloadState } from '@types';

export const BulkDownloadState = atom<TBulkDownloadState[]>({
	key: 'BulkDownloadState',
	default: [],
});
